module.exports = __webpack_public_path__ + "static/media/Landing_Imagen_Background.49351fd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/authentication/components/LandingTelmex/Landing_Imagen_Background.png
// module id = 1766
// module chunks = 0